import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import store from './redux/store';

import App from './containers/app/App';
import Maintenance from './containers/maintenance/Maintenance';

// Add plugins here to be available globally
import '@css/vendor.bundle.css';
import '@css/dataTables/datatables.css';
import '@css/app.bundle.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@css/skins/skin-master.css';
import '@css/custom.css';

const maintenanceMode = false;

ReactDOM.render((
  <Provider store={store}>
    <BrowserRouter>
      <QueryParamProvider ReactRouterRoute={Route}>
        <Route path="/*" component={maintenanceMode ? Maintenance : App} />
      </QueryParamProvider>
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));
